module.exports = __webpack_public_path__ + "/img/qbo-icon.da93ab0b42.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/qbo-icon.svg
// module id = 1394
// module chunks = 0